// Modules
import { createAction, props } from '@ngrx/store';

// Interfaces
import { IUser } from '@shared/interfaces/users';

// ----------- General Actions -----------
// ---------------------------------------
export const reset = createAction('[View Profile] - Reset');

export const getUserProfileRequested = createAction(
  '[View Profile] - Get User Profile Requested'
);

export const getUserProfileResponse = createAction(
  '[View Profile] - Get User Profile Response',
  props<{ payload: IUser }>()
);
